module.exports = __webpack_public_path__ + "static/media/book_bang_ae_dara_urdu_1.d6450142.jpg";